import {Button, FormControl, InputLabel, MenuItem, Select, Grid, Typography, Paper} from "@mui/material"
import React, {useState, useEffect} from "react"
import AlertMessage from "src/components/alert-message"
import DatePickerSelect from "src/components/date/date-picker-select"
import DateTimePickerSelectDate from "src/components/date/date-time-picker-select-date"
import {DATE_FORMAT} from "src/utils/constants"
import {IntegrationService} from "src/services/integration-service"
import dayjs from "dayjs"
import SkeletonTable from "src/components/skeleton-table"
import {DataGrid} from "@mui/x-data-grid"
import LoaderOverlay from "../../v2/components/LoaderOverlay/loader-overlay"
import Loader from "../../v2/components/Loader/loader"


const ReportDataWorkflowPage = () => {
    const [alertMessageState, setAlertMessageState] = useState({
        open: false,
        message: "",
        type: ""
    })

    const [dateSelected, setDateSelected] = useState(dayjs().subtract(7, 'day').set('hour', 19).set('minute', 15).set('second', 0).set('millisecond', 670))
    const [dateSelectedDate, setDateSelectedDate] = useState(dayjs())
    const [loading, setLoading] = useState(false)
    const [name, setName] = useState(null)
    const [loadTable, setLoadTable] = useState(false)
    const [setRoutineList] = useState([])
    const [tableData, setTableData] = useState([])
    const [columns, setColumns] = useState([])
    const integrationService = new IntegrationService()

    const alterarValor = (event) => {
        const selectedValue = event.target.value
        setName(selectedValue)
    }

    const closeAlert = () => {
        setAlertMessageState({...alertMessageState, open: false})
    }

    useEffect(() => {
        loadLastRoutines()
    }, [])

    const extractMetadata = (obj) => {
        const {metadata} = obj
        try {
            const valores = metadata.split(',')
            let data_referencia = valores.find(elemento => elemento.includes("data_referencia"))
            let qtde_dias = valores.find(elemento => elemento.includes("qtde_dias"))

            data_referencia !== undefined ? data_referencia = data_referencia.slice(-11).slice(0, -1) : null
            qtde_dias !== undefined ? qtde_dias = qtde_dias.slice(-3).slice(0, -1) : 0

            return {data_referencia: data_referencia, qtde_dias: qtde_dias}
        } catch (err) {
            return null
        }
    }

    const loadLastRoutines = () => {
        setLoadTable(true)
        integrationService.getRoutinesWorkflowInfo().then((response) => {
            const {body} = response
            const {results} = body
            const rows = results.map((obj, index) => {
                const metadata = extractMetadata(obj)

                return {
                    ...obj,
                    id: index,
                    data_referencia: metadata === null ? null : metadata.data_referencia,
                    qtde_dias: metadata === null ? 90 : metadata.qtde_dias,
                }
            })

            setRoutineList(rows)
            setLoadTable(false)
        }).catch((err) => {
            console.log(err)
            setLoadTable(false)
        })
    }

    const onChangeDatePickerDate = (value) => {
        setDateSelected(value)
    }

    const onChangeDatePickerDateTime = (value) => {
        const formattedDate = value.format(DATE_FORMAT)
        setDateSelectedDate(formattedDate)
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    const inicialRotina = () => {
        setLoading(true)
        setColumns([])
        setTableData([])

        const handleResponse = (response) => {
            try {
                const jsonData = JSON.parse(response.text)
                console.log('Dados recebidos da API:', jsonData)

                if (jsonData && Object.keys(jsonData).length > 0) {
                    const tableData = Object.keys(jsonData).map((key, index) => ({
                        id: `${key}_${index}_${Date.now()}`, // ID único incluindo timestamp
                        dados: key,
                        qtde: jsonData[key],
                    }))

                    console.log('Dados transformados para tabela:', tableData)

                    // Configuração das colunas
                    const generatedColumns = [
                        {field: 'dados', headerName: 'Dados', width: 200},
                        {field: 'qtde', headerName: 'Qtde', width: 200},
                    ]

                    // Atualizar estados para renderizar no DataGrid
                    setColumns(generatedColumns)
                    setTableData(tableData)
                } else {
                    openAlert('Nenhum dado disponível para exibir.', 'warning')
                }
            } catch (error) {
                console.error('Erro ao processar dados recebidos:', error)
                openAlert('Erro ao processar dados recebidos.', 'error')
            } finally {
                setLoading(false)
            }
        }

        const handleError = (error) => {
            console.error('Erro ao buscar dados:', error)
            openAlert('Erro ao buscar dados.', 'error')
            setLoading(false)
        }

        // Verificar se o name é "CVMCadastro"
        if (name === "CVMCadastro") {
            integrationService
                .getReportData(name)
                .then(handleResponse)
                .catch(handleError)
        } else {
            integrationService
                .getReportDataInfo(name, dateSelectedDate)
                .then(handleResponse)
                .catch(handleError)
        }
    }


    const inicialRotinaPeriodo = () => {
        setLoading(true)
        setColumns([])
        setTableData([])

        const formatHeader = (key) => {
            return key
                .replace(/_/g, ' ')
                .replace(/^\w/, (c) => c.toUpperCase())
        }

        const handleResponse = (response) => {
            try {
                const jsonData = JSON.parse(response.text)
                console.log('Dados recebidos da API:', jsonData)

                if (Array.isArray(jsonData) && jsonData.length > 0) {
                    // Extrair campos únicos do report, exceto metadata_output
                    const allReportKeys = new Set()
                    jsonData.forEach(item => {
                        if (item.report) {
                            Object.keys(item.report).forEach(key => {
                                if (key !== 'metadata_output') {
                                    allReportKeys.add(key)
                                }
                            })
                        }
                    })

                    const reportFields = Array.from(allReportKeys)

                    // Agrupar por lote_id
                    const groupedByLote = {}
                    jsonData.forEach(item => {
                        const lote = item.lote_id
                        if (!groupedByLote[lote]) {
                            groupedByLote[lote] = []
                        }
                        groupedByLote[lote].push(item)
                    })

                    // Montar dados com lote_id apenas na 1ª linha de cada grupo
                    const tableData = []
                    Object.entries(groupedByLote).forEach(([loteId, items]) => {
                        items.forEach((item, idx) => {
                            const row = {
                                id: `${loteId}_${idx}`,
                                lote_id: idx === 0 ? loteId : '', // apenas na primeira
                                data_referencia: item.data_referencia,
                            }

                            reportFields.forEach(field => {
                                let valor = item.report?.[field]
                                if (typeof valor === 'boolean') {
                                    valor = valor ? 'Sim' : 'Não'
                                }
                                row[field] = valor ?? ''
                            })

                            tableData.push(row)
                        })
                    })

                    // Colunas com renderCell para garantir ocultação visual
                    const generatedColumns = [
                        {
                            field: 'lote_id',
                            headerName: 'Lote ID',
                            width: 120,
                            renderCell: (params) => {
                                return params.value ? params.value : ''
                            }
                        },
                        {
                            field: 'data_referencia',
                            headerName: 'Data Referência',
                            width: 180,
                        },
                        ...reportFields.map(field => ({
                            field,
                            headerName: formatHeader(field),
                            width: 180,
                        })),
                    ]

                    setColumns(generatedColumns)
                    setTableData(tableData)
                } else {
                    openAlert('Nenhum dado disponível para exibir.', 'warning')
                }
            } catch (error) {
                console.error('Erro ao processar dados recebidos:', error)
                openAlert('Erro ao processar dados recebidos.', 'error')
            } finally {
                setLoading(false)
            }
        }

        const handleError = (error) => {
            console.error('Erro ao buscar dados:', error)
            openAlert('Erro ao buscar dados.', 'error')
            setLoading(false)
        }

        if (name === "CVMCadastro") {
            integrationService
                .getReportData(name)
                .then(handleResponse)
                .catch(handleError)
        } else {
            integrationService
                .getReportDataPeriodoInfo(name, dateSelectedDate)
                .then(handleResponse)
                .catch(handleError)
        }
    }


    return (
        <div>
            {
                loading && (
                    <LoaderOverlay>
                        <Loader/>
                    </LoaderOverlay>
                )
            }

            <AlertMessage open={alertMessageState.open} message={alertMessageState.message}
                          type={alertMessageState.type} close={closeAlert}/>

            <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={3}>
                <Grid item sm={12} md={6} xl={4} xs={12}>
                    <Typography variant={"h5"}>
                        Relatório de Dados
                    </Typography>
                </Grid>
            </Grid>
            <br/>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={3} xl={4}>
                    <FormControl fullWidth variant={"standard"}>
                        <InputLabel id="demo-simple-select-label">Selecione uma rotina</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={name}
                            label="Rotinas"
                            onChange={alterarValor}
                        >
                            <MenuItem value="b3acoes_neg_analitico_workflow">B3AcoesNegAnaliticoWorkflow</MenuItem>
                            <MenuItem value="b3acoes_neg_registrados_workflow">B3AcoesNegRegistradosWorkflow</MenuItem>
                            <MenuItem value="b3ativos_reg_workflow">B3AtivosRegWorkflow</MenuItem>
                            <MenuItem value="b3neg_analitico_workflow">B3NegAnaliticoWorkflow</MenuItem>
                            <MenuItem value="b3neg_consolidado_workflow">B3NegConsolidadoWorkflow</MenuItem>
                            <MenuItem value="bacen_cadastro_workflow">BacenCadastroWorkflow</MenuItem>
                            <MenuItem value="cvm_balanco_final_workflow">CVMBalancoWorkflow</MenuItem>
                            <MenuItem value="cvm_cadastro_workflow">CVMCadastroWorkflow</MenuItem>
                            <MenuItem value="cvm_fatos_relevantes_workflow">CVMFatosRelevantesWorflow</MenuItem>
                            <MenuItem value="coleta_de_taxas_e_risk_free_workflow">ColetEstoqueRegistradoWorkflow</MenuItem>
                            <MenuItem value="EstoqueRegistrado">EstoqueRegistradoWorflow</MenuItem>
                            <MenuItem value="fincs_marketdata_workflow">MarketData_airflow</MenuItem>
                            <MenuItem value="previa_inflacao_workflow">PreviaInflacaoWorflow</MenuItem>
                            <MenuItem value="TaxasRecebiveisMercado" disabled>TaxasRecebiveisMercado</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>

                {name === 'MarketData' && (
                    <Grid item xs={12} md={9} xl={4}>
                        <DateTimePickerSelectDate
                            label="Data de Exibição"
                            onChange={onChangeDatePickerDate}
                            value={dateSelected}
                        />
                    </Grid>
                )}

                <Grid item xs={12} md={9} xl={4}>
                    <DatePickerSelect
                        label="Data de Exibição"
                        onChange={onChangeDatePickerDateTime}
                        value={dateSelectedDate}
                    />
                </Grid>

                <Grid item xs={12} md={3} xl={4}>
                    <Button variant="contained" onClick={inicialRotina} fullWidth>Consultar</Button>
                </Grid>
                <Grid item xs={12} md={3} xl={4}>
                    <Button variant="contained" onClick={inicialRotinaPeriodo} fullWidth>Consultar 15 dias</Button>
                </Grid>
            </Grid>

            <Grid container direction="row" justifyContent="space-between" spacing={2} sx={{mt: 2, mb: 2}}>
                <Grid item>
                    <Typography variant={"h5"}>Relatório</Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    {loadTable ? <SkeletonTable/> : (
                        <div style={{height: 600, width: '100%'}}>
                            <Paper>
                                <DataGrid
                                    autoHeight={true}
                                    rows={tableData}
                                    columns={columns}
                                    getRowId={(row) => row.id}  // Configuração de ID personalizado
                                    pageSize={5}
                                    rowsPerPageOptions={[5]}
                                />
                            </Paper>
                        </div>
                    )}
                </Grid>
            </Grid>

        </div>
    )
}

export default ReportDataWorkflowPage